import styles from './single.module.scss';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BackButton } from '../../components';

const Single = ({children, title, subtitle}) => {
	const [t] = useTranslation();
	return (
		<section id="single" className={styles.container}>
			<div className={styles.content_wrapper}>
				<BackButton
				buttonText={t('nav.back')}
				href={""}
				/>
				<div className={styles.text_wrapper}>
					<h5>
						<b>{t('single.single001.braveUp')}</b>
					</h5>
					<h1 className={styles.title}>
						{title}
					</h1>
				</div>
				<div className={styles.single_content}>
				<p className={styles.subtitle}>
					{subtitle}
				</p>
					
				{/* <figure>
					<img
						className={styles.image}
						alt={t('single.single001.imageAlt')}
						src={ComputerImage}
					/>
				</figure> */}
				{children}
				</div>
			</div>
		</section>
	);
};

Single.propTypes = {
	children: PropTypes.any,
	title: PropTypes.string,
	subtitle: PropTypes.string
}

export default Single;

